import { SupplierId } from './supplier_id';

export class ItemKey {
  constructor(
    public _supplierId: SupplierId = new SupplierId(''),
    public _catalogItemCode: string = ''
  ) {}

  /// productName：
  /// ・アスクル商品の場合、catalogItemCodeを設定
  /// ・サプライヤ商品の場合、supplierIdとcatalogItemCodeを連結
  getProductName(): string {
    if (this._supplierId.isAskul()) {
      return this._catalogItemCode;
    }
    return `${this._supplierId.rawValue()}${this._catalogItemCode}`;
  }

  /// productName(soloel):
  getProductNameForSoloel(): string {
    return `${this._supplierId.rawValue()}${this._catalogItemCode}`;
  }
}
